module.exports = __webpack_public_path__ + "img/home_page_courier_img.878d0c3d.png";